import { ElementHTML } from '@helpers/helper.rendering'
import React, { useEffect, useState } from 'react'
import { RealEstateDataFooterData } from 'types'

const currentYear = new Date().getFullYear()

const isBrowser = typeof window !== 'undefined'
type CombinedProps = RealEstateDataFooterData

import FormComponent from '@components/footer/11/form/index'
import { useGetConfigurationsQuery } from '@apis/mediacore/configuration'

const Footer11 = ({
  global_data,
  title,
  titleElement,
  titleHexa,
  paragraphHexa,
  backgroundHexa,
  items,
  paragraph,
}: CombinedProps) => {
  const getCurrentYear = () => new Date().getFullYear()

  //   const [sendContactForm] = useSendContactFormMutation()
  //   const [sendContactFormMediacore] = useSendContactFormMutationMediacore()

  const [disabled, setDisabled] = useState(true)

  const realEstateName = global_data.name

  const sendForm = (e: { preventDefault: () => void }) => {
    // e.preventDefault()
    // const tags = ['Sitio Web', 'Newsletter', realEstateName]
    // sendContactFormMediacore({
    //   data: { ...datos, tags, token: token },
    //   type: 'newsletter',
    //   site: global_data.id,
    // })
    // ;(document.getElementById('formNewsletter') as HTMLFormElement)?.reset()
    // return toast.success('Te suscribiste a nuestro newsletter correctamente.')
  }

  const handleInputChange = (e: { target: { name: string; value: string } }) => {
    setDatos({
      ...datos,
      [e.target.name]: e.target.value,
    })
  }

  const [datos, setDatos] = useState({
    email: '',
  })

  const { data: modules } = useGetConfigurationsQuery(process.env.GATSBY_CLIENTID)

  const INVESTOR_CONFIGURATION = modules?.find(
    (config: { module: string }) => config.module === 'INVESTOR',
  )
  const OWNER_CONFIGURATION = modules?.find(
    (config: { module: string }) => config.module === 'OWNER',
  )

  useEffect(() => {
    const update = () => {
      // dispatch(updateFields(datos))
    }
    update()
    // if (!captcha) {
    //   setDisabled(false)
    // } else {
    //   setDisabled(true)
    // }
  }, [])

  const [isComponentMounted, setIsComponentMounted] = useState(false)

  useEffect(() => {
    setIsComponentMounted(true)
  }, [])

  const [token, setValueToken] = useState('')

  function onChange(value: any) {
    setValueToken(value)
  }

  const scrollTop = () => {
    if (isBrowser) {
      var body = $('html, body')
      body.stop().animate({ scrollTop: 0 }, 500, 'swing', function () {})
    }
  }

  return (
    <div
      className="footer-11"
      style={{ background: backgroundHexa || '#fff' }}
    >
      <section
        id="contacto"
        className="div_section_form position-relative"
      >
        <div className="container-fluid ">
          <div className="div_news_container">
            <div className="row ">
              <div className="div_title col-12 offset-lg-4 col-lg-12 text-start">
                <ElementHTML
                  elementType={titleElement || 'h5'}
                  children={title}
                  className="title-element"
                  style={{ color: titleHexa }}
                />
                <a
                  onClick={() => window.scrollTo(0, 0)}
                  className="section__five__arrow__top d-xl-block"
                >
                  <i className="icon-arrow-light"></i>
                </a>
              </div>
              <div className="div_first mb-2 col-12 col-lg-4 text-center text-lg-start d-none d-lg-block">
                {global_data.branches.map((branch) => (
                  <p
                    style={{ color: paragraphHexa }}
                    className="mb-0"
                  >
                    {branch.name} <br />
                    {branch.address}, CP {branch.zip_code} <br />
                    {branch.city}, {branch.country} <br />
                    {branch.contact_data.phonesLine.length > 0
                      ? 'Teléfono:' + branch.contact_data.phonesLine[0]
                      : ''}
                  </p>
                ))}
                {/* <a className='' target="_blank" href="mailto:comercial@unitequartier.com">comercial@unitequartier.com</a> */}
                {items?.map((item) => (
                  <div className="d-flex emails">
                    <p
                      style={{ lineHeight: 2, color: paragraphHexa }}
                      className="mb-0"
                    >
                      {item.title}{' '}
                    </p>
                    <a
                      style={{ lineHeight: 2, color: paragraphHexa }}
                      className="ms-2"
                      target="_blank"
                      href={'mailto:' + item.subtitle}
                    >
                      {item.subtitle}
                    </a>
                  </div>
                ))}
                {/* <div className="d-flex">
                  <p
                    style={{ lineHeight: 2, color: paragraphHexa }}
                    className="mb-0"
                  >
                    Cesiones y alquileres:{' '}
                  </p>
                  <a
                    style={{ lineHeight: 2, color: paragraphHexa }}
                    className="ms-2"
                    target="_blank"
                    href="mailto:comercial@unitequartier.com"
                  >
                    comercial@unitequartier.com
                  </a>
                </div> */}
              </div>

              <div className="div_second mb-2 col-12 col-lg-8 position-relative">
                <div className="row">
                  <FormComponent
                    paragraph=""
                    underlineMode={true}
                    button={{ link: '', value: 'Enviar' }}
                    global_data={global_data}
                    from="contacto"
                    title=""
                  />
                </div>
              </div>

              <div className="div_first mb-2 col-12 col-lg-4 text-center d-block d-lg-none">
                <p className="">
                  Distrito Quartier <br />
                  Comodoro Pedro Zanni 351 (Loft Norte PB 4), CP 1104, <br /> CABA Buenos Aires,
                  Argentina. <br /> Teléfono: +54 11 3991 3084
                </p>
                <a
                  className=""
                  target="_blank"
                  href="mailto:comercial@unitequartier.com"
                >
                  comercial@unitequartier.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer
        className="text-center row pb-5"
        style={{ margin: '0 auto' }}
      >
        <div className="col-12 col-lg-4 d-block font-1 justify-content-center align-self-end">
          {' '}
          <p className="m-0 p-0">{paragraph}</p>
        </div>
        <div className="col-12 col-lg-4 d-block">
          <div className="copy mt-auto d-flex">
            <p>
              {' '}
              Promoted by{' '}
              <a
                className="mediahaus-link"
                target="_blank"
                href="https://mediahaus.com.ar/"
              >
                {' '}
                MediaHaus{' '}
              </a>{' '}
              - Powered By{' '}
              <a
                className="mediacore-link"
                href="https://mediacore.app/"
              >
                MediaCore{' '}
              </a>
              <br />{' '}
              <span className="reservated">Todos los derechos reservados &reg; {currentYear} </span>
              <br />
              <span className="reservated">
                {process.env.GATSBY_COMMIT_HASH} {' - '} {process.env.GATSBY_GIT_TAG}{' '}
              </span>
            </p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Footer11
